import { render, staticRenderFns } from "./RecapDocumentsNumber.vue?vue&type=template&id=20f9e612"
import script from "./RecapDocumentsNumber.vue?vue&type=script&lang=js"
export * from "./RecapDocumentsNumber.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports